module.exports = __webpack_public_path__ + "static/media/create.552fcd66.svg";